export default __webpack_public_path__ + "static/media/LOGOTIPO.667c7abe.png";